/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * IN operator looks for values that are in the given list of values.
 */
export interface InKeyType {
    /** The values to compare against. */
    values: Truvity.InKeyTypeValuesItem[];
}
